import { useTranslation } from "react-i18next"
import { ItemMenu } from "../../../../../../components/baseMenu"
import { MenuType } from "../enum"

export const useMenu = (): ItemMenu[] => {
    const { t } = useTranslation()

    return [
        {
            label: t('general.edit'),
            value: MenuType.EDIT,
        },
        {
            label: t('general.delete'),
            value: MenuType.DELETE,
        },
    ]
}